import { render } from "./StaffDash.vue?vue&type=template&id=e1aa1536"
import script from "./StaffDash.vue?vue&type=script&lang=js"
export * from "./StaffDash.vue?vue&type=script&lang=js"

import "./StaffDash.vue?vue&type=style&index=0&id=e1aa1536&lang=css"

import exportComponent from "C:\\Users\\brinl\\Desktop\\FnixApp\\LatestsUpload\\fnx\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__